import React, { useEffect, useRef, useState } from 'react';
import { mappls } from 'mappls-web-maps';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import HttpAPICall from '../../services/HttpAPICall';
import Loader from '../../components/ui/Loader/Loader';

const AssetTracking = (props) => {

  const mapInstanceRef                      =   useRef(null);
  const polylineRef                         =   useRef(null);
  const mapplsInstanceRef                   =   useRef(null);
  const firstLoad                           =   useRef(false);
  const startMarkerRef                      =   useRef(null);
  const endMarkerRef                        =   useRef(null);
  const access_token                        =   useSelector(state => state.auth.access_token);
  const [imei, setImei]                     =   useState('');
  const [startDate, setStartDate]           =   useState('');
  const [endDate, setEndDate]               =   useState('');
  const [loading, setLoading]               =   useState(false);
  const [deviceData, setDeviceData]         =   useState(null);
  const [mapLoading, setMapLoading]         =   useState(false);
  const [mapError, setMapError]             =   useState(null);
  const mapAccessToken                      =   "onqfxjgqmpicvnzbuyyuctsmbwtdtopeogxd";

  useEffect(() => {
    const now = new Date();
    const twelveHoursAgo = new Date(
      now.getTime() -
      12 * 60 * 60 * 1000
    );
    setStartDate(twelveHoursAgo);
    setEndDate(now);
  }, []);


  useEffect(() => {
    if (props?.deviceData?.imei_no) {
      setImei(props.deviceData.imei_no)
    }
  }, [props?.deviceData?.imei_no]);

  useEffect(() => {
    if (!firstLoad.current && imei && startDate && endDate) {
      firstLoad.current = true;
      fetchDeviceData(
        imei,
        startDate,
        endDate
      );
    }

  }, [ imei, startDate, endDate]);

  const fetchDeviceData = (
    selectedImei,
    selectedStartDate,
    selectedEndDate
  ) => {

    setLoading(true);

    setDeviceData(null);

    setMapError(null);

    setMapLoading(false);


    const requestBody = {

      imeIs: [
        selectedImei.trim()
      ],

      startDate:
        new Date(
          selectedStartDate
        ).toISOString(),

      endDate:
        new Date(
          selectedEndDate
        ).toISOString()

    };


    HttpAPICall.withAthorization(

      'POST',

      'https://api6.tappetbox.in/api/DeviceData/get-historical',

      access_token,

      {},

      requestBody,

      (resp) => {
        setDeviceData(
          resp.data
        );
        toast.success(
          'Device data fetched successfully',
          {
            position:
              toast.POSITION.TOP_RIGHT
          }
        );

      },

      (error) => {

        console.error(
          'Device history error:',
          error
        );

        toast.error(
          'Failed to fetch device data',
          {
            position:
              toast.POSITION.TOP_RIGHT
          }
        );

      }

    ).finally(() => {

      setLoading(false);

    });

  };

  const handleDateTimeChange = (
    field,
    value
  ) => {

    if (field === 'startDate') {

      setStartDate(value);

    }

    if (field === 'endDate') {

      setEndDate(value);

    }

  };

  const handleSubmit = (e) => {

    e.preventDefault();


    if (!imei) {

      toast.error(
        'Please select an IMEI number',
        {
          position:
            toast.POSITION.TOP_RIGHT
        }
      );

      return;

    }


    if (!startDate || !endDate) {

      toast.error(
        'Please select both start and end dates',
        {
          position:
            toast.POSITION.TOP_RIGHT
        }
      );

      return;

    }


    if (
      new Date(startDate) >
      new Date(endDate)
    ) {

      toast.error(
        'Start date cannot be greater than end date',
        {
          position:
            toast.POSITION.TOP_RIGHT
        }
      );

      return;

    }


    fetchDeviceData(
      imei,
      startDate,
      endDate
    );

  };

  const getPathPoints = () => {

    if (!deviceData) {

      return [];

    }


    const dataArray =
      Array.isArray(deviceData)

        ? deviceData

        : (
          deviceData.data ||
          deviceData.result ||
          deviceData.records ||
          []
        );


    const points = dataArray

      .filter(item => {

        const lat =
          parseFloat(
            item.latitude
          );

        const lng =
          parseFloat(
            item.longitude
          );


        return (
          Number.isFinite(lat) &&
          Number.isFinite(lng)
        );

      })

      .map(item => ({

        lat:
          parseFloat(
            item.latitude
          ),

        lng:
          parseFloat(
            item.longitude
          )

      }));

    return points;

  };

  const getLocationDetails = async (lat, lng) => {

    try {

      const url =
        `https://search.mappls.com/search/address/rev-geocode?lat=${lat}&lng=${lng}&access_token=${mapAccessToken}`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error('Reverse geocoding failed');
      }

      const data = await response.json();


      if (
        data?.results &&
        data.results.length > 0
      ) {

        return data.results[0];

      }

      return null;

    } catch (error) {

      console.error(
        'Reverse geocoding error:',
        error
      );

      return null;

    }

  };

  useEffect(() => {

    if (!deviceData) {
      return;
    }

    const points = getPathPoints();

    if (!points.length) {
      setMapError('No valid location data found');
      setMapLoading(false);
      return;
    }

    let isMounted = true;

    const cleanupMap = () => {

      if (
        mapplsInstanceRef.current &&
        mapInstanceRef.current
      ) {

        if (startMarkerRef.current) {

          try {

            mapplsInstanceRef.current.removeLayer({
              map: mapInstanceRef.current,
              layer: startMarkerRef.current
            });

          } catch (error) {
            console.log('Start marker cleanup:', error);
          }

        }

        if (endMarkerRef.current) {

          try {

            mapplsInstanceRef.current.removeLayer({
              map: mapInstanceRef.current,
              layer: endMarkerRef.current
            });

          } catch (error) {
            console.log('End marker cleanup:', error);
          }

        }
      }

      if (
        polylineRef.current &&
        mapInstanceRef.current
      ) {

        try {

          mapplsInstanceRef.current?.removeLayer({
            map: mapInstanceRef.current,
            layer: polylineRef.current
          });

        } catch (error) {
          console.log('Polyline cleanup:', error);
        }

      }

      polylineRef.current = null;

      if (mapInstanceRef.current) {

        try {

          mapInstanceRef.current.remove();

        } catch (error) {

          console.log('Map cleanup:', error);

        }

      }

      mapInstanceRef.current = null;
      mapplsInstanceRef.current = null;

      startMarkerRef.current = null;
      endMarkerRef.current = null;
    };

    const initializeMap = () => {

      try {

        setMapLoading(true);
        setMapError(null);

        const mapplsInstance = new mappls();

        mapplsInstanceRef.current = mapplsInstance;

        mapplsInstance.initialize(

          mapAccessToken,

          {
            map: true,
            version: '3.0'
          },

          () => {

            if (!isMounted) {
              return;
            }

            const firstPoint = points[0];

            const map = mapplsInstance.Map({

              id: 'tracking-map',

              properties: {

                center: [
                  firstPoint.lat,
                  firstPoint.lng
                ],

                zoom: 15,

                zoomControl: true,

                clickableIcons: true,

                traffic: false,

                geolocation: true

              }

            });

            mapInstanceRef.current = map;



            map.on('load', async () => {

              if (!isMounted) {
                return;
              }

              setMapLoading(false);

              mapplsInstance.setStyle(
                'standard-hybrid'
              );
              const startPoint = points[0];
              const endPoint = points[points.length - 1];
              const [
                startLocation,
                endLocation
              ] = await Promise.all([
                getLocationDetails(
                  startPoint.lat,
                  startPoint.lng
                ),
                getLocationDetails(
                  endPoint.lat,
                  endPoint.lng
                )
              ]);

              const polyline =
                mapplsInstance.Polyline({

                  map: map,

                  paths: points,

                  strokeColor: '#1677ff',

                  strokeOpacity: 1,

                  strokeWeight: 6,

                  fitbounds: true,

                  fitboundOptions: {

                    padding: 80,

                    duration: 1000,

                    maxZoom: 17

                  },

                  animate: {

                    speed: 5,

                    icon_width: 42,

                    icon_height: 25,

                    icon_url: 'https://maps.google.com/mapfiles/kml/shapes/cabs.png',
                    icon_offset: [-21, -12],
                    repeat: true,
                    rotation: true,
                    autoRotate: true,

                  }

                });


              polylineRef.current = polyline;

              const startAddress =
                startLocation?.formatted_address ||
                'Location not available';

              const startArea =
                startLocation?.area ||
                startLocation?.locality ||
                startLocation?.subLocality ||
                startLocation?.village ||
                '-';

              const startCity =
                startLocation?.city ||
                startLocation?.district ||
                '-';

              const startState =
                startLocation?.state ||
                '-';

              const startPincode =
                startLocation?.pincode ||
                '-';


              const startPopup = `
  <div
    style="
      min-width:250px;
      max-width:300px;
      padding:10px;
    "
  >

    <div
      style="
        font-size:17px;
        font-weight:700;
        margin-bottom:12px;
      "
    >
      🟢 Start Point
    </div>

    <div style="font-size:13px;margin-bottom:7px;">
      <b>Area:</b> ${startArea}
    </div>

    <div style="font-size:13px;margin-bottom:7px;">
      <b>City:</b> ${startCity}
    </div>

    <div style="font-size:13px;margin-bottom:7px;">
      <b>State:</b> ${startState}
    </div>

    <div style="font-size:13px;margin-bottom:7px;">
      <b>Pincode:</b> ${startPincode}
    </div>

    <div style="font-size:13px;margin-bottom:10px;">
      <b>Address:</b><br/>
      ${startAddress}
    </div>

    <div
      style="
        border-top:1px solid #eee;
        padding-top:8px;
        font-size:12px;
        color:#777;
      "
    >
      <b>Lat:</b> ${startPoint.lat.toFixed(6)}
      <br/>
      <b>Lng:</b> ${startPoint.lng.toFixed(6)}
    </div>

  </div>
`;


              const startMarker =
                mapplsInstance.Marker({

                  map: map,

                  position: {
                    lat: startPoint.lat,
                    lng: startPoint.lng
                  },

                  icon: 'https://cdn.jsdelivr.net/gh/pointhi/leaflet-color-markers@master/img/marker-icon-2x-green.png'
                  ,

                  width: 42,

                  height: 42,

                  popupHtml: startPopup,

                  popupOptions: {
                    openPopup: false,
                    autoClose: true,
                    maxWidth: 320
                  }

                });

              startMarkerRef.current = startMarker;


              startMarker.addListener(
                'click',
                async () => {

                  const loadingPopup =
                    new mapplsInstance.InfoWindow({

                      map: map,

                      position: {
                        lat: startPoint.lat,
                        lng: startPoint.lng
                      },

                      content: `
          <div
            style="
              min-width:220px;
              padding:8px;
            "
          >

            <div
              style="
                font-size:16px;
                font-weight:700;
                margin-bottom:8px;
                 color: #4caf50;  
              "
            >
              🟢 Start Point
            </div>

            <div
              style="
                font-size:13px;
                color:#666;
              "
            >
              Loading location...
            </div>

          </div>
        `,

                      closeButton: true

                    });


                  // ---------------------------------------------
                  // Get actual location
                  // ---------------------------------------------

                  const location =
                    await getLocationDetails(
                      startPoint.lat,
                      startPoint.lng
                    );


                  // ---------------------------------------------
                  // Prepare address
                  // ---------------------------------------------

                  const address =
                    location?.formatted_address
                    || 'Location not available';

                  const area =
                    location?.area
                    || location?.locality
                    || location?.subLocality
                    || location?.village
                    || '-';

                  const city =
                    location?.city
                    || location?.district
                    || '-';

                  const state =
                    location?.state
                    || '-';

                  const pincode =
                    location?.pincode
                    || '-';


                  // ---------------------------------------------
                  // Update popup
                  // ---------------------------------------------

                  loadingPopup.setContent(`

      <div
        style="
          min-width:250px;
          max-width:300px;
          padding:8px;
           border-left: 4px solid #4caf50; 
        "
      >

        <div
          style="
            font-size:17px;
            font-weight:700;
            color:#222;
            margin-bottom:12px;
          "
        >
          🟢 Start Point
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:7px;
          "
        >
          <b>Area:</b>
          ${area}
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:7px;
          "
        >
          <b>City:</b>
          ${city}
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:7px;
          "
        >
          <b>State:</b>
          ${state}
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:7px;
          "
        >
          <b>Pincode:</b>
          ${pincode}
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:10px;
          "
        >
          <b>Address:</b><br/>
          ${address}
        </div>


        <div
          style="
            border-top:1px solid #eee;
            padding-top:8px;
            font-size:12px;
            color:#777;
          "
        >
          <b>Lat:</b>
          ${startPoint.lat.toFixed(6)}
          <br/>

          <b>Lng:</b>
          ${startPoint.lng.toFixed(6)}
        </div>

      </div>

    `);

                }
              );
              startMarkerRef.current =
                startMarker;
              const endAddress =
                endLocation?.formatted_address ||
                'Location not available';

              const endArea =
                endLocation?.area ||
                endLocation?.locality ||
                endLocation?.subLocality ||
                endLocation?.village ||
                '-';

              const endCity =
                endLocation?.city ||
                endLocation?.district ||
                '-';

              const endState =
                endLocation?.state ||
                '-';

              const endPincode =
                endLocation?.pincode ||
                '-';


              const endPopup = `
  <div
    style="
      min-width:250px;
      max-width:300px;
      padding:10px;
    "
  >

    <div
      style="
        font-size:17px;
        font-weight:700;
        margin-bottom:12px;
      "
    >
      🔴 End Point
    </div>

    <div style="font-size:13px;margin-bottom:7px;">
      <b>Area:</b> ${endArea}
    </div>

    <div style="font-size:13px;margin-bottom:7px;">
      <b>City:</b> ${endCity}
    </div>

    <div style="font-size:13px;margin-bottom:7px;">
      <b>State:</b> ${endState}
    </div>

    <div style="font-size:13px;margin-bottom:7px;">
      <b>Pincode:</b> ${endPincode}
    </div>

    <div style="font-size:13px;margin-bottom:10px;">
      <b>Address:</b><br/>
      ${endAddress}
    </div>

    <div
      style="
        border-top:1px solid #eee;
        padding-top:8px;
        font-size:12px;
        color:#777;
      "
    >
      <b>Lat:</b> ${endPoint.lat.toFixed(6)}
      <br/>
      <b>Lng:</b> ${endPoint.lng.toFixed(6)}
    </div>

  </div>
`;


              const endMarker =
                mapplsInstance.Marker({

                  map: map,

                  position: {
                    lat: endPoint.lat,
                    lng: endPoint.lng
                  },

                  icon: 'https://cdn.jsdelivr.net/gh/pointhi/leaflet-color-markers@master/img/marker-icon-2x-red.png',

                  width: 42,

                  height: 42,

                  popupHtml: endPopup,

                  popupOptions: {
                    openPopup: false,
                    autoClose: true,
                    maxWidth: 320
                  }

                });

              endMarkerRef.current = endMarker;

              endMarker.addListener(
                'click',
                async () => {
                  const loadingPopup =
                    new mapplsInstance.InfoWindow({

                      map: map,

                      position: {
                        lat: endPoint.lat,
                        lng: endPoint.lng
                      },

                      content: `
          <div
            style="
              min-width:220px;
              padding:8px;
            "
          >

            <div
              style="
                font-size:16px;
                font-weight:700;
                margin-bottom:8px;
              "
            >
              🔴 End Point
            </div>

            <div
              style="
                font-size:13px;
                color:#666;
              "
            >
              Loading location...
            </div>

          </div>
        `,

                      closeButton: true

                    });

                  const location =
                    await getLocationDetails(
                      endPoint.lat,
                      endPoint.lng
                    );
                  const address =
                    location?.formatted_address
                    || 'Location not available';

                  const area =
                    location?.area
                    || location?.locality
                    || location?.subLocality
                    || location?.village
                    || '-';

                  const city =
                    location?.city
                    || location?.district
                    || '-';

                  const state =
                    location?.state
                    || '-';

                  const pincode =
                    location?.pincode
                    || '-';


                  loadingPopup.setContent(`

      <div
        style="
          min-width:250px;
          max-width:300px;
          padding:8px;
        "
      >

        <div
          style="
            font-size:17px;
            font-weight:700;
            color:#222;
            margin-bottom:12px;
          "
        >
          🔴 End Point
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:7px;
          "
        >
          <b>Area:</b>
          ${area}
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:7px;
          "
        >
          <b>City:</b>
          ${city}
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:7px;
          "
        >
          <b>State:</b>
          ${state}
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:7px;
          "
        >
          <b>Pincode:</b>
          ${pincode}
        </div>


        <div
          style="
            font-size:13px;
            color:#444;
            margin-bottom:10px;
          "
        >
          <b>Address:</b><br/>
          ${address}
        </div>


        <div
          style="
            border-top:1px solid #eee;
            padding-top:8px;
            font-size:12px;
            color:#777;
          "
        >
          <b>Lat:</b>
          ${endPoint.lat.toFixed(6)}
          <br/>

          <b>Lng:</b>
          ${endPoint.lng.toFixed(6)}
        </div>

      </div>

    `);

                }
              );

              endMarkerRef.current =
                endMarker;




            });

          }

        );

      } catch (error) {

        console.error(
          'Map initialization error:',
          error
        );

        if (isMounted) {

          setMapError(
            'Failed to initialize map: ' +
            error.message
          );

          setMapLoading(false);

        }

      }

    };
    cleanupMap();
    initializeMap();

    return () => {

      isMounted = false;

      cleanupMap();

    };

  }, [deviceData]);

  return (

    <div className="page_containt row pl2">

      <div className="pageTbl col-12 pl4">

        <div className="bg-white p-3">

          {props?.deviceData?.asset && (

            <table className="table table-hover table-borderless mt-2">

              <tbody>

                <tr>

                  <td
                    className="details-label"
                    style={{
                      width: '34%'
                    }}
                  >
                    Asset
                  </td>


                  <td
                    className="details-name"
                    style={{
                      width: '66%'
                    }}
                  >

                    {
                      props
                        ?.deviceData
                        ?.asset
                        ?.asset_name
                      || '-'
                    }

                    (

                    {
                      props
                        ?.deviceData
                        ?.asset
                        ?.asset_nickname
                      || '-'
                    }

                    )

                  </td>

                </tr>


                <tr>

                  <td
                    className="details-label"
                    style={{
                      width: '34%'
                    }}
                  >
                    Group
                  </td>


                  <td
                    className="details-name"
                    style={{
                      width: '66%'
                    }}
                  >

                    {
                      props
                        ?.deviceData
                        ?.group
                        ?.group_name
                      || '-'
                    }

                  </td>

                </tr>

              </tbody>

            </table>

          )}

          <form onSubmit={handleSubmit}>
            <div className="row align-items-center my-3">

              <div className="col-sm-4">

                <label
                  htmlFor="imei"
                  className="form-label require"
                >
                  IMEI
                </label>

              </div>


              <div className="col-sm-4">

                <input
                  type="text"
                  id="imei"
                  className="form-control"
                  value={imei || ''}
                  readOnly
                  disabled
                  placeholder="IMEI Number"
                />

              </div>

            </div>

            <div className="row align-items-center my-3">

              <div className="col-sm-4">

                <label
                  htmlFor="startDate"
                  className="form-label require"
                >
                  Start Date
                </label>

              </div>


              <div className="col-sm-4">

                <DatePicker

                  selected={
                    startDate
                  }

                  onChange={value =>
                    handleDateTimeChange(
                      'startDate',
                      value
                    )
                  }

                  dateFormat="dd-MMM-yyyy HH:mm"

                  className="form-control"

                  showMonthDropdown

                  showYearDropdown

                  showTimeSelect

                  timeFormat="HH:mm"

                  timeIntervals={15}

                  timeCaption="Time"

                  autoComplete="off"

                  scrollMonthYearDropdown

                  required

                  placeholderText="Please Enter Start Date & Time"

                />

              </div>

            </div>

            <div className="row align-items-center my-3">

              <div className="col-sm-4">

                <label
                  htmlFor="endDate"
                  className="form-label require"
                >
                  End Date
                </label>

              </div>


              <div className="col-sm-4">

                <DatePicker

                  selected={
                    endDate
                  }

                  onChange={value =>
                    handleDateTimeChange(
                      'endDate',
                      value
                    )
                  }

                  dateFormat="dd-MMM-yyyy HH:mm"

                  className="form-control"

                  showMonthDropdown

                  showYearDropdown

                  showTimeSelect

                  timeFormat="HH:mm"

                  timeIntervals={15}

                  timeCaption="Time"

                  autoComplete="off"

                  scrollMonthYearDropdown

                  required

                  placeholderText="Please Enter End Date & Time"

                />

              </div>

            </div>


            <div className="row align-items-center my-3">

              <div className="col-sm-7"></div>

              <div className="col-sm-2">

                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary"
                >

                  GO

                  {loading && (

                    <span className="ms-2">

                      <i className="fa fa-refresh fa-spin"></i>

                    </span>

                  )}

                </button>

              </div>

            </div>

          </form>

          {deviceData && !loading && (

            <div
              className="tracking-map-wrapper mb-5"
              style={{
                position: 'relative',
                width: '100%',
                height: '500px',
                marginTop: '20px',
                overflow: 'hidden',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                background: '#f5f5f5'
              }}
            >

              <div
                id="tracking-map"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  margin: 0,
                  padding: 0
                }}
              />

              {!mapLoading && !mapError && (

                <div
                  style={{
                    position: 'absolute',
                    bottom: '20px',
                    left: '20px',
                    zIndex: 20,
                    background: '#fff',
                    borderRadius: '10px',
                    padding: '16px 18px',
                    boxShadow:
                      '0 2px 10px rgba(0,0,0,.18)',
                    minWidth: '150px'
                  }}
                >

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '14px'
                    }}
                  >

                    <span
                      style={{
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        background: '#4caf50',
                        border: '3px solid white',
                        boxShadow:
                          '0 0 0 2px #4caf50',
                        marginRight: '12px'
                      }}
                    />

                    <span
                      style={{
                        fontSize: '14px',
                        color: '#222'
                      }}
                    >
                      Start Point
                    </span>

                  </div>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '14px'
                    }}
                  >

                    <span
                      style={{
                        width: '18px',
                        height: '18px',
                        borderRadius: '50%',
                        background: '#ef2929',
                        border: '3px solid white',
                        boxShadow:
                          '0 0 0 2px #ef2929',
                        marginRight: '12px'
                      }}
                    />

                    <span
                      style={{
                        fontSize: '14px',
                        color: '#222'
                      }}
                    >
                      End Point
                    </span>

                  </div>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '14px'
                    }}
                  >

                    <span
                      style={{
                        width: '22px',
                        height: '4px',
                        background: '#1677ff',
                        marginRight: '12px',
                        display: 'inline-block'
                      }}
                    />

                    <span
                      style={{
                        fontSize: '14px',
                        color: '#222'
                      }}
                    >
                      Route
                    </span>

                  </div>

                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >

                    <span
                      style={{
                        fontSize: '21px',
                        width: '22px',
                        marginRight: '12px',
                        textAlign: 'center'
                      }}
                    >
                      🚗
                    </span>

                    <span
                      style={{
                        fontSize: '14px',
                        color: '#222'
                      }}
                    >
                      Moving Vehicle
                    </span>

                  </div>

                </div>

              )}

              {mapLoading && (

                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background:
                      'rgba(255,255,255,0.90)',
                    zIndex: 1000
                  }}
                >

                  <Loader />

                  <p
                    className="mt-2 mb-0"
                    style={{
                      fontSize: '14px'
                    }}
                  >
                    Loading map...
                  </p>

                </div>

              )}

              {mapError && (

                <div
                  style={{
                    position: 'absolute',
                    inset: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background:
                      'rgba(255,255,255,0.95)',
                    zIndex: 1000
                  }}
                >

                  <h5>
                    Map Error
                  </h5>

                  <p>
                    {mapError}
                  </p>

                </div>

              )}

            </div>

          )}

          {loading && (

            <Loader />

          )}

        </div>

      </div>

    </div>

  );

};

export default AssetTracking;